const PaymentMethodEnum = {
  BANK_TRANSFER: 'Transakcijski račun'
  };

export default PaymentMethodEnum;